import {Component, OnInit, Input} from '@angular/core';
import { SoudotecEmplacementInputModel } from '../soudotec-emplacement-input.model';
import { Model_WorkflowComponent } from '../../../../../app.models';

@Component({
    selector: 'soudotec-emplacement-input-result',
    templateUrl: './soudotec-emplacement-input-result.component.html',
    styleUrls: ['./soudotec-emplacement-input-result.component.scss']
})
export class SoudotecEmplacementInputResultComponent implements OnInit {
    @Input() model: SoudotecEmplacementInputModel;
    @Input() value: any[];
    component: Model_WorkflowComponent;

    constructor() {
    }

    ngOnInit() {
        this.component = this.model.additional as Model_WorkflowComponent;
    }
}